import { render, staticRenderFns } from "./IssueTrackerDashboard.vue?vue&type=template&id=c06b8a36&scoped=true"
import script from "./IssueTrackerDashboard.vue?vue&type=script&lang=js"
export * from "./IssueTrackerDashboard.vue?vue&type=script&lang=js"
import style0 from "./IssueTrackerDashboard.vue?vue&type=style&index=0&id=c06b8a36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06b8a36",
  null
  
)

export default component.exports